import Vue from 'vue'

export async function createOrder ({ commit }, order) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    const { data } = await Vue.axios({
      method: 'POST',
      url: '/v1/orders',
      data: order
    })
    return data
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function getOrders ({ commit }) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setOrders', null)
    const { data } = await Vue.axios({
      url: '/v1/orders'
    })
    commit('setOrders', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function getMoreOrders ({ commit }, url) {
  try {
    commit('shared/setError', null, { root: true })
    commit('shared/setLoading', true, { root: true })

    const { data } = await Vue.axios({
      url
    })

    commit('addOrders', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function getOrder ({ commit }, orderID) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setOrder', null)
    const { data } = await Vue.axios({
      method: 'GET',
      url: `/v1/orders/${orderID}`
    })
    commit('setOrder', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function getOrderByOrderNumber ({ commit }, orderNumber) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    commit('setOrder', null)
    const { data } = await Vue.axios({
      method: 'GET',
      url: `/v1/orders/${orderNumber}?search_type=order-number`
    })
    commit('setOrder', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}
